module.exports = __webpack_public_path__ + "assets/systemExpense.7b4ec60d.svg";